export default __webpack_public_path__ + "static/media/cyberpunk.99b763a7.mp3";